<template>
  <div>
    <section class="mb-4">
      <div class="container">
        <div class="px-2 py-4 px-md-4 py-md-3 bg-white shadow-sm rounded">
          <div class="d-flex mb-3 align-items-baseline border-bottom">
            <h3 class="h5 fw-700 mb-0">
              <span
                class="border-bottom border-primary border-width-2 pb-3 d-inline-block"
                >{{ $t("最畅销的商家") }}
              </span>
            </h3>
            <router-link
              class="ml-auto mr-0 btn btn-primary btn-sm shadow-md"
              to="/sellers"
              >{{ $t("查看所有的商家") }}
            </router-link>
          </div>
          <div
            class="aiz-carousel gutters-10 half-outside-arrow slick-initialized slick-slider"
            data-items="3"
            data-lg-items="3"
            data-md-items="2"
            data-rows="2"
            data-sm-items="2"
            data-xs-items="1"
          >
            <button class="slick-prev slick-arrow" type="button" @click="prev">
              <i class="las la-angle-left"></i>
            </button>
            <div class="slick-list draggable">
              <van-swipe
                ref="swipe"
                :autoplay="999999999"
                :loop="false"
                :show-indicators="false"
                :width="itemWidth"
              >
                <van-swipe-item v-for="index of halfListLength" :key="index">
                  <div
                    aria-hidden="false"
                    class="slick-slide slick-current slick-active"
                    data-slick-index="0"
                    style="width:100%"
                  >
                    <template v-for="index2 of 2">
                      <SellerItem
                        v-if="list[(index - 1) * 2 + (index2 - 1)]"
                        :key="index2"
                        :item="list[(index - 1) * 2 + (index2 - 1)]"
                      />
                    </template>
                  </div>
                </van-swipe-item>
              </van-swipe>
            </div>
            <button class="slick-next slick-arrow" type="button" @click="next">
              <i class="las la-angle-right"></i>
            </button>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import SellerItem from "@/components/SellerItem.vue";
import { DeviceUtil } from "@/utils/deviceUtil";
import { getShopList } from "@/api/userShop";

export default {
  components: { SellerItem },
  // todo 暂时还没有最好的商家数据
  data() {
    return {
      itemWidth: 448,
      list: []
    };
  },
  computed: {
    halfListLength() {
      return Math.ceil(this.list.length / 2);
    }
  },
  methods: {
    prev() {
      this.$refs.swipe.prev();
    },
    next() {
      this.$refs.swipe.next();
    },
    async getList() {
      const res = await getShopList();
      this.list = res.data.records;
    }
  },
  mounted() {
    if (DeviceUtil.isMobile()) {
      this.itemWidth = this.$refs.swipe.clientWidth;
    }
  },
  created() {
    this.getList();
  }
};
</script>
